import LeaseholdModel from 'src/models/leasehold/Leasehold';
import { Reducer, Action } from 'redux';
import { IRootState } from './index';
import { actionCreators as layoutActionCreators } from 'src/reducers/Layout';
import { call, select, put, takeEvery, fork, delay, all } from 'redux-saga/effects';
import { selectors as authSelectors } from 'src/reducers/Auth';
import Api from '../api';
import moment from 'moment';
import { replace, push } from 'connected-react-router';
import AddWIOwnershipData from 'src/models/tract_detail/add_ownership_revised/AddWIOwnership';
import { ODataOptions, ODataFilter, ODataFilterOperators } from 'src/util/ODataBuilder';
import LeaseholdOwnership from 'src/models/leasehold/LeaseholdOwnership';
import ErrorResponse from 'src/models/ErrorResponse';
import ContractOwnershipList from 'src/models/ContractOwnershipList';

// tslint:disable: max-line-length
// Store
export interface ILeaseholdState {
    leasehold: LeaseholdModel;
    leaseholds: Array<LeaseholdModel>;
    // TODO: delete if un-needed later and can use this ^
    tractLeaseholds: Array<LeaseholdModel>;
    tractContracts: Array<ContractOwnershipList>;
    // ownerInfo: AnyObject;
    error: string;
}

const initialState: ILeaseholdState = {
    leasehold: undefined,
    leaseholds: undefined,
    tractLeaseholds: undefined,
    tractContracts: undefined,
    error: undefined,

    // ownerInfo: undefined,
};

// Action Types
export enum actionTypes {
    GET_LEASEHOLD = '[leasehold] GET_LEASEHOLD',
    GET_LEASEHOLD_SUCCESS = '[leasehold] GET_LEASEHOLD_SUCCESS',
    GET_LEASEHOLDS = '[leasehold] GET_LEASEHOLDS',
    GET_LEASEHOLDS_SUCCESS = '[leasehold] GET_LEASEHOLDS_SUCCESS',
    GET_LEASEHOLDS_BY_TRACT = '[leasehold] GET_LEASEHOLDS_BY_TRACT',
    GET_LEASEHOLDS_BY_TRACT_SUCCESS = '[leasehold] GET_LEASEHOLDS_BY_TRACT_SUCCESS',
    GET_CONTRACTS = '[leasehold] GET_CONTRACTS',
    GET_CONTRACTS_SUCCESS = '[lesaehold] GET_CONTRACTS_SUCCESS',
    CHOOSE_ACTIVE_LEASEHOLD = '[leasehold] CHOOSE_ACTIVE_LEASEHOLD',
    SAVE_LEASEHOLD = '[leasehold] SAVE_LEASEHOLD',
    UPDATE_LEASEHOLDS = '[leasehold] UPDATE_LEASEHOLDS',
    SAVE_LEASEHOLD_SUCCESS = '[leasehold] SAVE_LEASEHOLD_SUCCESS',
    SAVE_ADD_OWNERSHIP = '[leasehold] SAVE_ADD_OWNERSHIP',
    SAVE_ADD_OWNERSHIP_SUCCESS = '[leasehold] SAVE_ADD_OWNERSHIP_SUCCESS',
    DELETE_LEASEHOLD_OWNERSHIP = '[leasehold] DELETE_LEASEHOLD_OWNERSHIP',
    DELETE_LEASEHOLD = '[leasehold] DELETE_LEASEHOLD',
    MANAGE_LEASEHOLD = '[leasehold] MANAGE_LEASEHOLD',
    MANAGE_LEASEHOLD_SUCCESS = '[leasehold] MANAGE_LEASEHOLD_SUCCESS',
    UPDATE_OWNER_NOTE = '[leasehold] UPDATE_OWNER_NOTE',
    UPDATE_OWNER_NOTE_SUCCESS = '[leasehold] UPDATE_OWNER_NOTE_SUCCESS',
    UPDATE_OWNER_NOTE_ERROR = '[leasehold] UPDATE_OWNER_NOTE_ERROR',

    // GET_OWNER_INFO = '[leasehold] GET_OWNER_INFO',
    // GET_OWNER_INFO_SUCCESS = '[leasehold] GET_OWNER_INFO_SUCCESS',
}

// Action Creators
export const actionCreators = {
    getLeasehold: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        ownershipId: number,
        leaseholdId: number
    ) => {
        return { type: actionTypes.GET_LEASEHOLD, payload: { clientNumber, projectNumber, sectionNumber, tractNumber, ownershipId, leaseholdId } };
    },
    getLeaseholdSuccess: (leasehold: LeaseholdModel) => {
        return { type: actionTypes.GET_LEASEHOLD_SUCCESS, payload: leasehold };
    },
    getLeaseholds: (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number, ownershipId: number) => {
        return { type: actionTypes.GET_LEASEHOLDS, payload: { clientNumber, projectNumber, sectionNumber, tractNumber, ownershipId } };
    },
    getContracts: (clientNumber: number, projectNumber: number, ownershipId: number, inHanded: boolean) => {
        return { type: actionTypes.GET_CONTRACTS, payload: { clientNumber, projectNumber, ownershipId, inHanded } };
    },
    getContractsSuccess: (leaseholds: Array<ContractOwnershipList>) => {
        return { type: actionTypes.GET_CONTRACTS_SUCCESS, payload: leaseholds };
    },
    getLeaseholdsSuccess: (leaseholds: Array<LeaseholdModel>) => {
        return { type: actionTypes.GET_LEASEHOLDS_SUCCESS, payload: leaseholds };
    },
    getLeaseholdsByTract: (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number) => {
        return { type: actionTypes.GET_LEASEHOLDS_BY_TRACT, payload: { clientNumber, projectNumber, sectionNumber, tractNumber } };
    },
    getLeaseholdsByTractSuccess: (leaseholds: Array<LeaseholdModel>) => {
        return { type: actionTypes.GET_LEASEHOLDS_BY_TRACT_SUCCESS, payload: leaseholds };
    },
    chooseActiveLeasehold: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        ownershipId: number,
        leaseholdId: number
    ) => {
        return {
            type: actionTypes.CHOOSE_ACTIVE_LEASEHOLD,
            payload: { clientNumber, projectNumber, sectionNumber, tractNumber, ownershipId, leaseholdId },
        };
    },
    updateLeaseholds: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        leaseholds: Array<LeaseholdModel>
    ) => {
        return {
            type: actionTypes.UPDATE_LEASEHOLDS,
            payload: { clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, leaseholds },
        };
    },
    updateOwnerNote: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        ownership: LeaseholdOwnership
    ) => {
        return {
            type: actionTypes.UPDATE_OWNER_NOTE,
            payload: { clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, ownership },
        };
    },

    updateOwnerNoteSuccess: () => {
        return { type: actionTypes.UPDATE_OWNER_NOTE_SUCCESS };
    },
    updateOwnerNoteError: (payload: ErrorResponse) => {
        return { type: actionTypes.UPDATE_OWNER_NOTE_ERROR, payload: payload };
    },
    saveLeasehold: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        leasehold: LeaseholdModel
    ) => {
        return { type: actionTypes.SAVE_LEASEHOLD, payload: { clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, leasehold } };
    },
    saveAddOwnership: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        ownershipId: number,
        leaseholdId: number,
        values: AddWIOwnershipData
    ) => {
        return {
            type: actionTypes.SAVE_ADD_OWNERSHIP,
            payload: { clientNumber, projectNumber, sectionNumber, tractNumber, ownershipId, leaseholdId, values },
        };
    },
    deleteLeaseholdOwnership: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        ownershipId: number,
        leaseholdId: number,
        leaseholdOwnershipId: number
    ) => {
        return {
            type: actionTypes.DELETE_LEASEHOLD_OWNERSHIP,
            payload: { clientNumber, projectNumber, sectionNumber, tractNumber, ownershipId, leaseholdId, leaseholdOwnershipId },
        };
    },
    deleteLeasehold: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        ownershipId: number,
        leaseholdId: number,
        switchLeaseholdId: number
    ) => {
        return {
            type: actionTypes.DELETE_LEASEHOLD,
            payload: { clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, ownershipId, leaseholdId, switchLeaseholdId },
        };
    },
    manageleasehold: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        ownershipId: number
    ) => {
        return {
            type: actionTypes.MANAGE_LEASEHOLD,
            payload: { clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, ownershipId },
        };
    },
    // getOwnerInfo: (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number, ownershipId: number)
};

// Reducer
const reducer: Reducer<ILeaseholdState> = (state: ILeaseholdState = initialState, action: Action): ILeaseholdState => {
    switch (action.type) {
        case actionTypes.GET_LEASEHOLD_SUCCESS: {
            const payload = (action as { type: string; payload: LeaseholdModel }).payload;
            return {
                ...state,
                leasehold: payload,
            };
        }
        case actionTypes.GET_LEASEHOLDS_SUCCESS: {
            const payload = (action as { type: string; payload: Array<LeaseholdModel> }).payload;
            return {
                ...state,
                leaseholds: payload,
            };
        }
        case actionTypes.GET_LEASEHOLDS_BY_TRACT_SUCCESS: {
            const payload = (action as { type: string; payload: Array<LeaseholdModel> }).payload;
            return {
                ...state,
                tractLeaseholds: payload,
            };
        }
        case actionTypes.GET_CONTRACTS_SUCCESS: {
            const payload = (action as { type: string; payload: Array<ContractOwnershipList> }).payload;
            return {
                ...state,
                tractContracts: payload,
            };
        }
        case actionTypes.UPDATE_OWNER_NOTE_ERROR: {
            const payload = (action as { type: string; payload: ErrorResponse }).payload;
            return {
                ...state,
                error: payload.message,
            };
        }
        default:
            return state;
    }
};

export default reducer;

// Selectors
const leaseholdSelector = (state: IRootState): LeaseholdModel => state.leasehold.leasehold;
const leaseholdsSelector = (state: IRootState): Array<LeaseholdModel> => state.leasehold.leaseholds;

export const selectors = {
    leasehold: leaseholdSelector,
    leaseholds: leaseholdsSelector,
};

// Side-Effects
const sagas = {
    getLeasehold: function* (action: {
        type: string;
        payload: {
            clientNumber: number;
            projectNumber: number;
            sectionNumber: number;
            tractNumber: number;
            ownershipId: number;
            leaseholdId: number;
        };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const { clientNumber, projectNumber, sectionNumber, tractNumber, ownershipId, leaseholdId } = action.payload;
        const result = yield call(Api.Leasehold.getLeasehold, clientNumber, projectNumber, sectionNumber, tractNumber, ownershipId, leaseholdId, jwt);
        if (result && result.leaseDate) {
            result.leaseDate = moment(result.leaseDate).format('YYYY-MM-DD');
        }
        if (result && result.effectiveDate) {
            result.effectiveDate = moment(result.effectiveDate).format('YYYY-MM-DD');
        }
        if (result && result.expirationDate) {
            result.expirationDate = moment(result.expirationDate).format('YYYY-MM-DD');
        }
        yield put(actionCreators.getLeaseholdSuccess(result));
        // yield put(layoutActionCreators.hideDialog());
    },
    deteleLeasehold: function* (action: {
        type: string;
        payload: {
            clientNumber: number;
            projectNumber: number;
            sectionNumber: number;
            tractNumber: number;
            horizonNumber: number;
            ownershipId: number;
            leaseholdId: number;
            switchLeaseholdId: number;
        };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const { clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, ownershipId, leaseholdId, switchLeaseholdId } =
            action.payload;
        yield call(Api.Leasehold.deleteLeasehold, clientNumber, projectNumber, sectionNumber, tractNumber, ownershipId, leaseholdId, jwt);
        yield put(layoutActionCreators.hideDialog());
        yield put(replace('/'));
        yield put(
            replace(
                `/clients/${clientNumber}/projects/${projectNumber}/sections/${sectionNumber}/tracts/${tractNumber}/horizons/${horizonNumber}/ownership/${ownershipId}/leasehold/${switchLeaseholdId}`
            )
        );
    },
    getLeaseholds: function* (action: {
        type: string;
        payload: { clientNumber: number; projectNumber: number; sectionNumber: number; tractNumber: number; ownershipId: number };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const result = yield call(
            Api.Leasehold.getLeaseholds,
            action.payload.clientNumber,
            action.payload.projectNumber,
            action.payload.sectionNumber,
            action.payload.tractNumber,
            action.payload.ownershipId,
            jwt
        );

        LeaseholdModel.cleanDates(result as Array<LeaseholdModel>);

        yield put(actionCreators.getLeaseholdsSuccess(result));
    },
    getLeaseholdsByTract: function* (action: {
        type: string;
        payload: { clientNumber: number; projectNumber: number; sectionNumber: number; tractNumber: number };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const result = yield call(
            Api.Leasehold.getLeaseholdsByTract,
            action.payload.clientNumber,
            action.payload.projectNumber,
            action.payload.sectionNumber,
            action.payload.tractNumber,
            jwt
        );

        LeaseholdModel.cleanDates(result as Array<LeaseholdModel>);

        yield put(actionCreators.getLeaseholdsByTractSuccess(result));
    },
    getContracts: function* (action: {
        type: string;
        payload: { clientNumber: number; projectNumber: number; ownershipId: number, inHanded: boolean };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const result = yield call(
            Api.Leasehold.getContracts,
            action.payload.clientNumber,
            action.payload.projectNumber,
            action.payload.ownershipId,
            action.payload.inHanded,
            jwt
        );

        ContractOwnershipList.cleanDates(result as Array<ContractOwnershipList>);

        yield put(actionCreators.getContractsSuccess(result));
    },
    updateLeaseholds: function* (action: {
        type: string;
        payload: {
            clientNumber: number;
            projectNumber: number;
            sectionNumber: number;
            tractNumber: number;
            horizonNumber: number;
            leaseholds: Array<LeaseholdModel>;
        };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const { clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, leaseholds } = action.payload;
        yield call(Api.Leasehold.updateLeaseholds, clientNumber, projectNumber, sectionNumber, tractNumber, leaseholds, jwt);
        yield put(replace('/'));
        yield put(
            replace(`/clients/${clientNumber}/projects/${projectNumber}/sections/${sectionNumber}/tracts/${tractNumber}/horizons/${horizonNumber}`)
        );
    },
    chooseActiveLeasehold: function* (action: {
        type: string;
        payload: {
            clientNumber: number;
            projectNumber: number;
            sectionNumber: number;
            tractNumber: number;
            ownershipId: number;
            leaseholdId: number;
        };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const { clientNumber, projectNumber, sectionNumber, tractNumber, ownershipId, leaseholdId } = action.payload;
        yield call(Api.Leasehold.chooseActiveLeasehold, clientNumber, projectNumber, sectionNumber, tractNumber, ownershipId, leaseholdId, jwt);
        yield put(actionCreators.getLeaseholds(clientNumber, projectNumber, sectionNumber, tractNumber, ownershipId));
        yield put(layoutActionCreators.hideDialog());
    },
    saveLeasehold: function* (action: {
        type: string;
        payload: {
            clientNumber: number;
            projectNumber: number;
            sectionNumber: number;
            tractNumber: number;
            horizonNumber: number;
            leasehold: LeaseholdModel;
        };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const { clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, leasehold } = action.payload;
        const result: { id: number } = yield call(
            Api.Leasehold.saveLeasehold,
            clientNumber,
            projectNumber,
            sectionNumber,
            tractNumber,
            leasehold,
            jwt
        );
        yield put(
            replace(
                `/clients/${clientNumber}/projects/${projectNumber}/sections/${sectionNumber}/tracts/${tractNumber}/horizons/${horizonNumber}/ownership/${leasehold.ownershipId}/leasehold/${result.id}`
            )
        );
        // TODO: really don't do this just get an understanding of react final form and re initialize the form. or change the form toggles for lease clauses.
        location.reload();
    },
    saveAddOwnership: function* (action: {
        type: string;
        payload: {
            clientNumber: number;
            projectNumber: number;
            sectionNumber: number;
            tractNumber: number;
            ownershipId: number;
            leaseholdId: number;
            values: AddWIOwnershipData;
        };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);

        const jwt = yield select(authSelectors.jwt);
        const { clientNumber, projectNumber, sectionNumber, tractNumber, ownershipId, leaseholdId, values } = action.payload;
        const typedValues = AddWIOwnershipData.typedObject(values);

        if (typedValues.ownership && leaseholdId) {
            typedValues.ownership.leaseholdId = leaseholdId;
        }
        yield call(Api.Leasehold.saveAddOwnership, clientNumber, projectNumber, sectionNumber, tractNumber, ownershipId, typedValues, jwt);

        const options = new ODataOptions();
        const ownershipFilter = new ODataFilter('horizonId', ODataFilterOperators.Equals, action.payload.values.horizonId);
        options.addFilter(ownershipFilter);
        options.addPaging(1, 6);

        yield put(layoutActionCreators.hideDialog());
    },

    deleteLeaseholdOwnership: function* (action: {
        type: string;
        payload: {
            clientNumber: number;
            projectNumber: number;
            sectionNumber: number;
            tractNumber: number;
            ownershipId: number;
            leaseholdId: number;
            leaseholdOwnershipId: number;
        };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const { clientNumber, projectNumber, sectionNumber, tractNumber, ownershipId, leaseholdId, leaseholdOwnershipId } = action.payload;

        yield call(
            Api.Leasehold.deleteLeaseholdOwnership,
            clientNumber,
            projectNumber,
            sectionNumber,
            tractNumber,
            ownershipId,
            leaseholdId,
            leaseholdOwnershipId,
            jwt
        );

        yield put(layoutActionCreators.hideDialog());

        // TODO: not good
        location.reload();
    },
    updateOwnerNote: function* (action: {
        type: string;
        payload: {
            clientNumber: number;
            projectNumber: number;
            sectionNumber: number;
            tractNumber: number;
            horizonNumber: number;
            ownership: LeaseholdOwnership;
        };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const { clientNumber, projectNumber, sectionNumber, tractNumber, ownership } = action.payload;

        // TODO: updateOwnerNote, change backend to use horizonId after resolving horizonNumber
        const [result] = yield all([
            yield call(Api.Leasehold.updateOwnerNote, clientNumber, projectNumber, sectionNumber, tractNumber, ownership.id, ownership, jwt),
            delay(200),
        ]);
        if (result instanceof ErrorResponse) {
            yield put(actionCreators.updateOwnerNoteError(result));
        } else {
            yield put(actionCreators.updateOwnerNoteSuccess());
            yield put(layoutActionCreators.hideDialog());
            location.reload();
        }
    },

    manageleasehold: function* (action: {
        type: string;
        payload: {
            clientNumber: number;
            projectNumber: number;
            sectionNumber: number;
            tractNumber: number;
            horizonNumber: number;
            ownershipId: number;
        };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const { clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, ownershipId } = action.payload;

        const result: Array<LeaseholdModel> = yield call(
            Api.Leasehold.getLeaseholds,
            clientNumber,
            projectNumber,
            sectionNumber,
            tractNumber,
            ownershipId,
            jwt
        );

        if (result?.length > 0) {
            const active = result.find((lm: LeaseholdModel) => lm.isActiveLease) || result[0];
            yield put(
                push(
                    `/clients/${clientNumber}/projects/${projectNumber}/sections/${sectionNumber}/tracts/${tractNumber}/horizons/${horizonNumber}/ownership/${ownershipId}/leasehold/${active.id}`
                )
            );
        } else {
            const newLeasehold = new LeaseholdModel();
            newLeasehold.id = 0;
            newLeasehold.isActiveLease = true;
            newLeasehold.ownershipId = ownershipId;

            yield put(actionCreators.saveLeasehold(clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, newLeasehold));
        }
    },
};

// Watches
const watches = {
    getLeasehold: function* () {
        yield takeEvery(actionTypes.GET_LEASEHOLD, sagas.getLeasehold);
    },
    getLeaseholds: function* () {
        yield takeEvery(actionTypes.GET_LEASEHOLDS, sagas.getLeaseholds);
    },
    getLeaseholdsByTract: function* () {
        yield takeEvery(actionTypes.GET_LEASEHOLDS_BY_TRACT, sagas.getLeaseholdsByTract);
    },
    getContracts: function* () {
        yield takeEvery(actionTypes.GET_CONTRACTS, sagas.getContracts);
    },
    chooseActiveLeasehold: function* () {
        yield takeEvery(actionTypes.CHOOSE_ACTIVE_LEASEHOLD, sagas.chooseActiveLeasehold);
    },
    updateOwnerNote: function* () {
        yield takeEvery(actionTypes.UPDATE_OWNER_NOTE, sagas.updateOwnerNote);
    },
    saveLeasehold: function* () {
        yield takeEvery(actionTypes.SAVE_LEASEHOLD, sagas.saveLeasehold);
    },
    saveAddOwnership: function* () {
        yield takeEvery(actionTypes.SAVE_ADD_OWNERSHIP, sagas.saveAddOwnership);
    },
    updateLeaseholds: function* () {
        yield takeEvery(actionTypes.UPDATE_LEASEHOLDS, sagas.updateLeaseholds);
    },
    deleteLeaseholdOwnership: function* () {
        yield takeEvery(actionTypes.DELETE_LEASEHOLD_OWNERSHIP, sagas.deleteLeaseholdOwnership);
    },
    manageleasehold: function* () {
        yield takeEvery(actionTypes.MANAGE_LEASEHOLD, sagas.manageleasehold);
    },
    deleteLeasehold: function* () {
        yield takeEvery(actionTypes.DELETE_LEASEHOLD, sagas.deteleLeasehold);
    },
};

// Forks
export function* saga() {
    yield fork(watches.getLeasehold);
    yield fork(watches.getLeaseholds);
    yield fork(watches.getLeaseholdsByTract);
    yield fork(watches.getContracts);
    yield fork(watches.updateOwnerNote);
    yield fork(watches.chooseActiveLeasehold);
    yield fork(watches.saveLeasehold);
    yield fork(watches.updateLeaseholds);
    yield fork(watches.saveAddOwnership);
    yield fork(watches.deleteLeaseholdOwnership);
    yield fork(watches.manageleasehold);
    yield fork(watches.deleteLeasehold);
}



// WEBPACK FOOTER //
// ./src/reducers/Leasehold.ts